import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {ConfiguratorProviderService, SelectItem} from '@tj/tj-dmp-lib-api';

@Component({
    selector: 'dmp-select-provider',
    templateUrl: './select-provider.component.html',
    styleUrls: ['./select-provider.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: SelectProviderComponent
        }
    ],
    standalone: false
})
export class SelectProviderComponent implements OnChanges, ControlValueAccessor {

    constructor(private configuratorProviderService: ConfiguratorProviderService) {
    }

    provider: SelectItem;
    providers: SelectItem[];

    @Input() datastore: string;
    @Input() value: string;
    @Output() change = new EventEmitter<SelectItem>();
    @Input() disabled = false;
    @Input() cache: false;
    touched = false;

    onChange = (value) => {
    };
    onTouched = () => {
    };

    private loadProvider() {

        this.configuratorProviderService.getAllProvidersUsingGET(this.datastore).subscribe(res => {
            this.providers = [];
            res.forEach(item => {
                this.providers.push({
                    value: item.code,
                    label: item.name
                });
            });
        });
  }

  writeValue(codeProvider: any): void {
    this.value = codeProvider;
    this.updateValue();
  }
  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }
  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }
  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.value) {
            this.updateValue();
        }
        if (changes.datastore && this.datastore != null) {
            this.loadProvider();
        }
    }

    private updateValue() {
        if (this.providers == null) {
            return;
        }
        if (this.value) {
            this.provider = this.providers.find(d => d.value == this.value);
            return;
        }
        this.providerChange();
    }

    providerChange() {
        if (this.provider != null && !this.disabled) {
            this.onChange((this.provider as SelectItem).value);
            this.markAsTouched();
            this.change.emit(this.provider);
        }
    }

}
